import React, {Component} from "react";
import {ModalBody, ModalFooter} from "reactstrap";
import {Spinner} from "../../../Spinner";
import { withTranslation } from "react-i18next";

class SellLeadFormInModal extends Component {
    constructor(props) {
        super(props);
        this.state = {
            saving: false,
        };
        this.handleSubmit = this.handleSubmit.bind(this);
    }

    handleSubmit(event) {
        event.preventDefault();
        const amount = event.target.amount.value;
        this.props.onSubmit(this.props.leadId, amount)
    }

    renderSaveButton() {
        const { t } = this.props;
        if (!this.state.saving) {
            return <input type="submit" value={t('ok_button')} className="btn -alt"/>
        } else {
            return <Spinner color="positive small"/>;
        }
    }

    render() {
        const { t } = this.props;
        return (
            <form onSubmit={this.handleSubmit}>
                <ModalBody className="crm-modal-body">
                    <div className="form-big-input -price">
                        <label>{t('sell_lead_form.amount')}</label>
                        <div className="money-input"><p>$</p><input name="amount" type="number"/></div>
                    </div>
                </ModalBody>
                <ModalFooter>
                    {this.renderSaveButton()}
                </ModalFooter>
            </form>
        )
    }
}

export default withTranslation()(SellLeadFormInModal);